module.exports = __webpack_public_path__ + "img/baklava.cd565ed0.png";